// Map prod → stage hosts
const HOSTNAME_REWRITES: Record<string, string> = {
  "apps.hbs.edu": "apps.hbsstg.org",
  "community.alumni.harvard.edu": "acetst.cadm.harvard.edu",
};

export function rewriteExternalUrlForStage(
  originalUrl: string,
  isStage: boolean,
): string {
  if (!isStage) return originalUrl;

  for (const [prodHost, stageHost] of Object.entries(HOSTNAME_REWRITES)) {
    const httpsPrefix = `https://${prodHost}`;
    const protoPrefix = `//${prodHost}`;

    if (originalUrl.startsWith(httpsPrefix)) {
      return `https://${stageHost}` + originalUrl.substring(httpsPrefix.length);
    }

    if (originalUrl.startsWith(protoPrefix)) {
      return `//${stageHost}` + originalUrl.substring(protoPrefix.length);
    }
  }

  return originalUrl;
}
